import React from "react";
import { TrendingUp, Map, Lightbulb } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Growth Solutions",
  description: "Accelerate your market presence with data-driven strategies designed to scale your operations and maximize ROI effectively.",
  icon: TrendingUp,
  link: "/GrowthSolutionsPage"
}, {
  title: "The Strategist",
  description: "Comprehensive strategic planning that aligns your business objectives with actionable insights for long-term success.",
  icon: Map,
  link: "/TheStrategistPage"
}, {
  title: "Business Advisory",
  description: "Expert guidance to navigate complex challenges, optimize organizational performance, and unlock new opportunities.",
  icon: Lightbulb,
  link: "/GetStartedPage"
}];
export default function ServiceOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="service-overview" ref={ref} className={`bg-background py-32 transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {services.map((service, i) => <div key={i} data-index={i} className="group flex flex-col items-start h-full">
              {}
              <div className="mb-8 flex h-16 w-16 items-center justify-center border border-accent bg-transparent transition-transform duration-500 ease-[cubic-bezier(0.25,1,0.5,1)] group-hover:scale-105">
                <service.icon className="h-8 w-8 text-[var(--color-green-700)]" strokeWidth={0.75} />
              </div>

              {}
              <h3 className="mb-4 font-serif text-2xl text-primary">
                {service.title}
              </h3>
              <p className="mb-8 flex-grow font-sans text-base leading-[1.6] text-muted-foreground">
                {service.description}
              </p>

              {}
              <Button asChild variant="ghost" className="h-auto rounded-[2px] border border-accent px-6 py-2 text-sm font-medium hover:bg-accent/10">
                <Link to={service.link}>Explore Service</Link>
              </Button>
            </div>)}
        </div>
      </div>
    </section>;
}